import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Card, CardContent, Grid } from '@mui/material';
import { ICardLine } from './ICardLine';

export default function CustomisedCardBullet({ firstTitle, bulletColor }: ICardLine) {
    return (
        <>
            <Card
                className=" !shadow-none "
                style={{
                    marginTop: '0.7rem',
                    lineHeight: '1.5rem',
                    background: "transparent"
                }}
            >
                <CardContent className="paddingBottom bg-[var(--input-bg-color)] border-[var(--border-color)] rounded-[8px]">
                    <Grid container xs={12} style={{ display: 'flex' }}>
                        <Grid item xs={0.6} sx={{ color: bulletColor }} className="secondaryColorLight " style={{ marginTop: '-1px' }}>
                            <FiberManualRecordIcon
                                style={{ width: '12px', height: '12px', marginTop: '1px' }}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={11.4}
                            className="text-[var(--primary-text-color)] text-sm  anjomanRegular mr-0"
                            style={{ lineHeight: '1.5rem', textAlign: 'justify' }}
                        >
                            {firstTitle}{' '}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}
